export default "__VITE_ASSET__36f662b5__"